import { render, staticRenderFns } from "./DistrictsTable.vue?vue&type=template&id=f5af7458&"
import script from "./DistrictsTable.vue?vue&type=script&lang=js&"
export * from "./DistrictsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports